if (window.matchMedia && window.matchMedia('(pointer:fine)').matches){
  document.querySelectorAll('.zw').forEach(function(w){
    var img = w.querySelector('img');
    var lens = document.createElement('div');
    lens.className = 'zlens';
    w.appendChild(lens);
    var Z = 2.2, S = 340;
    w.addEventListener('mousemove', function(e){
      var r = img.getBoundingClientRect();
      var x = e.clientX - r.left, y = e.clientY - r.top;
      lens.style.display = 'block';
      lens.style.left = (x - S/2) + 'px';
      lens.style.top = (y - S/2) + 'px';
      lens.style.backgroundImage = 'url("' + (img.currentSrc || img.src) + '")';
      lens.style.backgroundSize = (r.width*Z) + 'px ' + (r.height*Z) + 'px';
      lens.style.backgroundPosition = (-(x*Z - S/2)) + 'px ' + (-(y*Z - S/2)) + 'px';
    });
    w.addEventListener('mouseleave', function(){ lens.style.display = 'none'; });
  });
}
function openSignup(){ var o=document.getElementById('overlay'); if(o) o.classList.add('open'); }

/* ---- scroll-triggered signup popup (runs on the live store) ---- */
(function(){
  var o = document.getElementById('overlay');
  if (!o) return;
  var C = window.GLVSSIC_POPUP || {};
  if (C.enabled === false) return;

  /* never interrupt someone who is buying */
  if (/^\/(cart|checkouts?|account|challenge|orders)/.test(location.pathname)) return;

  var KEY = 'glv_popup_v1';
  function read(){ try{ return JSON.parse(localStorage.getItem(KEY) || '{}'); }catch(e){ return {}; } }
  function write(s){ try{ localStorage.setItem(KEY, JSON.stringify(s)); }catch(e){} }

  var st = read();
  if (st.subscribed) return;                                   // already on the list
  var snooze = (C.snoozeDays == null ? 7 : C.snoozeDays) * 864e5;
  if (st.dismissedAt && Date.now() - st.dismissedAt < snooze) return;

  var needPct = C.scrollPct == null ? 45 : C.scrollPct;
  var needMs  = (C.delaySec  == null ? 6  : C.delaySec) * 1000;
  var t0 = Date.now(), fired = false, timer = null;

  function stop(){
    fired = true;
    window.removeEventListener('scroll', check);
    if (timer) clearInterval(timer);
  }
  function check(){
    if (fired) return;
    if (o.classList.contains('open')) { stop(); return; }       // they opened it themselves
    if (document.querySelector('.overlay.open')) return;        // notify modal is up — wait
    if (Date.now() - t0 < needMs) return;
    var doc  = document.documentElement;
    var span = doc.scrollHeight - window.innerHeight;
    var pct  = span > 40 ? (window.scrollY / span) * 100 : 100; // short page -> time only
    if (pct < needPct) return;
    stop();
    openSignup();
    var s = read(); s.shownAt = Date.now(); write(s);
  }

  window.addEventListener('scroll', check, {passive:true});
  timer = setInterval(check, 1200);

  /* closing it (X or backdrop) snoozes the popup */
  o.addEventListener('click', function(e){
    var isX = e.target.classList && e.target.classList.contains('x');
    if (e.target === o || isX){
      var s = read();
      if (!s.subscribed){ s.dismissedAt = Date.now(); write(s); }
    }
  });
})();
(function(){
  var o = document.getElementById('overlay');
  if (!o) return;
  o.addEventListener('click', function(e){ if (e.target === o) o.classList.remove('open'); });
  var CC1 = document.getElementById('ccode1');
  if (window.GLVPhone) GLVPhone.init(CC1, document.getElementById('phone'));
  function normalizePhone(raw){
    return window.GLVPhone ? GLVPhone.normalize(CC1, raw) : null;
  }
    /* visitor IP for Klaviyo geolocation — same-origin trace first, ipify fallback */
    var VISITOR_IP = null;
    fetch('/cdn-cgi/trace').then(function(r){return r.text();}).then(function(t){
      var m = t.match(/^ip=(.+)$/m); if (m) VISITOR_IP = m[1];
    }).catch(function(){}).then(function(){
      if (!VISITOR_IP) return fetch('https://api.ipify.org').then(function(r){return r.text();})
        .then(function(ip){ if (/^[0-9a-f.:]+$/i.test(ip)) VISITOR_IP = ip; }).catch(function(){});
    });
  var form = document.getElementById('signup');
  if (!form) return;
  /* phone formatting handled by GLVPhone */
  form.addEventListener('submit', function(e){
    e.preventDefault();
    var msg = document.getElementById('msg'), btn = document.getElementById('goBtn');
    msg.textContent=''; msg.className='msg';
    var email = document.getElementById('email').value.trim();
    var phone = normalizePhone(document.getElementById('phone').value.trim());
    if(!email || !/.+@.+\..+/.test(email)){ msg.textContent='Enter a valid email.'; msg.className='msg err'; return; }
    if(!phone || phone.replace(/\D/g,'').length < 8){ msg.textContent='Enter a valid phone number.'; msg.className='msg err'; return; }
    btn.disabled = true; btn.textContent = 'Signing up...';
    var payload = { data:{ type:'subscription', attributes:{ profile:{ data:{ type:'profile', attributes:{
      email: email, phone_number: phone,
      subscriptions: { email:{ marketing:{ consent:'SUBSCRIBED' } }, sms:{ marketing:{ consent:'SUBSCRIBED' } } } } } } },
      relationships:{ list:{ data:{ type:'list', id:'WVxK3Z' } } } } };
    if (VISITOR_IP) payload.data.attributes.profile.data.attributes.location = { ip: VISITOR_IP };
    var SURL = 'https://a.klaviyo.com/client/subscriptions/?company_id=UgshUa';
    var SH = { 'Content-Type':'application/json', 'revision':'2025-07-15' };
    function sendSub(pl){
      return fetch(SURL, { method:'POST', headers:SH, body: JSON.stringify(pl) })
        .then(function(res){
          if(res.ok || res.status === 202) return true;
          return res.text().then(function(t){
            if(/phone_number|phone number/i.test(t)) return false;   /* phone rejected -> fall back */
            throw new Error('bad');
          });
        });
    }
    /* fallback 1: keep the phone, drop SMS consent (number's country not SMS-enabled) */
    var fb1 = JSON.parse(JSON.stringify(payload));
    delete fb1.data.attributes.profile.data.attributes.subscriptions.sms;
    /* fallback 2: phone won't store at all — keep it as a property so the signup never dies */
    var fb2 = JSON.parse(JSON.stringify(fb1));
    delete fb2.data.attributes.profile.data.attributes.phone_number;
    fb2.data.attributes.profile.data.attributes.properties = { 'Unverified Phone': phone };
    sendSub(payload)
    .then(function(ok){ return ok || sendSub(fb1); })
    .then(function(ok){ return ok || sendSub(fb2); })
    .then(function(ok){
      if(!ok) throw new Error('bad');
      try{ if(window.klaviyo) klaviyo.identify({ '$email': email }); }catch(_){}
      try{ localStorage.setItem('glv_popup_v1', JSON.stringify({subscribed:true})); }catch(_){}
      document.getElementById('mForm').classList.add('hiddenv');
      document.getElementById('mDone').classList.remove('hiddenv');
    })
    .catch(function(){
      msg.textContent='Something went wrong. Please try again.';
      msg.className='msg err';
      btn.disabled=false; btn.textContent='Sign Up';
    });
  });
})();

document.querySelectorAll('.sv-media').forEach(function(m){
  var v = m.querySelector('video'), b = m.querySelector('.sv-sound');
  if(!v || !b) return;
  v.muted = true;
  b.addEventListener('click', function(e){
    e.preventDefault(); e.stopPropagation();
    document.querySelectorAll('.sv-media video').forEach(function(o){
      if(o !== v){ o.muted = true; var ob = o.parentNode.querySelector('.sv-sound'); if(ob) ob.innerHTML = '&#128263;'; }
    });
    v.muted = !v.muted;
    b.innerHTML = v.muted ? '&#128263;' : '&#128266;';
    if(!v.muted) v.play();
  });
});

/* ---- per-product "Get Notified" (sold-out grid cards) ---- */
(function(){
  var ov = document.getElementById('notifyOverlay');
  if (!ov) return;
  var imgEl  = document.getElementById('nImg');
  var nameEl = document.getElementById('nName');
  var phoneEl= document.getElementById('nPhone');
  var form   = document.getElementById('notifyForm');
  var btn    = document.getElementById('nBtn');
  var msgEl  = document.getElementById('nMsg');
  var current = {};

  var CC2 = document.getElementById('ccode2');
  var emailWrap = document.getElementById('nEmailWrap');
  var emailEl   = document.getElementById('nEmail');
  if (window.GLVPhone) GLVPhone.init(CC2, phoneEl);

  /* visitor IP for Klaviyo geolocation — same-origin trace first, ipify fallback */
  var NOTIFY_IP = null;
  fetch('/cdn-cgi/trace').then(function(r){ return r.text(); }).then(function(t){
    var m = t.match(/^ip=(.+)$/m); if (m) NOTIFY_IP = m[1];
  }).catch(function(){}).then(function(){
    if (!NOTIFY_IP) return fetch('https://api.ipify.org').then(function(r){ return r.text(); })
      .then(function(ip){ if (/^[0-9a-f.:]+$/i.test(ip)) NOTIFY_IP = ip; }).catch(function(){});
  });
  function norm(raw){
    return window.GLVPhone ? GLVPhone.normalize(CC2, raw) : null;
  }
  /* phone formatting handled by GLVPhone */

  function close(){ ov.classList.remove('open'); }
  ov.addEventListener('click', function(e){
    if (e.target === ov || (e.target.classList && e.target.classList.contains('x'))) close();
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && ov.classList.contains('open')) close();
  });

  document.addEventListener('click', function(e){
    var b = e.target.closest ? e.target.closest('[data-notify-title]') : null;
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    current = {
      title:  b.getAttribute('data-notify-title') || 'This Piece',
      img:    b.getAttribute('data-notify-img')   || '',
      handle: b.getAttribute('data-notify-handle')|| '',
      id:     b.getAttribute('data-notify-id')    || ''
    };
    imgEl.src = current.img; imgEl.alt = current.title;
    nameEl.textContent = current.title;
    document.getElementById('nForm').classList.remove('hiddenv');
    document.getElementById('nDone').classList.add('hiddenv');
    if (emailWrap){ emailWrap.classList.add('hiddenv'); emailEl.value=''; }
    msgEl.textContent = ''; msgEl.className = 'msg';
    btn.disabled = false; btn.textContent = 'Text Me The Code';
    ov.classList.add('open');
  });

  form.addEventListener('submit', function(e){
    e.preventDefault();
    msgEl.textContent=''; msgEl.className='msg';
    var phone = norm(phoneEl.value.trim());
    if(!phone || phone.replace(/\D/g,'').length < 8){
      msgEl.textContent='Enter a valid phone number.'; msgEl.className='msg err'; return;
    }
    btn.disabled = true; btn.textContent = 'Signing up...';

    var sub = { data:{ type:'subscription', attributes:{ profile:{ data:{ type:'profile', attributes:{
      phone_number: phone,
      properties: { 'Last Wanted Item': current.title },
      subscriptions:{ sms:{ marketing:{ consent:'SUBSCRIBED' } } } } } } },
      relationships:{ list:{ data:{ type:'list', id:'WVxK3Z' } } } } };
    if (NOTIFY_IP) sub.data.attributes.profile.data.attributes.location = { ip: NOTIFY_IP };

    var H = { 'Content-Type':'application/json', 'revision':'2025-07-15' };
    var KURL = 'https://a.klaviyo.com/client/subscriptions/?company_id=UgshUa';
    function finish(idAttrs){
      var ev = { data:{ type:'event', attributes:{
        properties:{ 'Item': current.title, 'Handle': current.handle, 'Product ID': current.id, 'Phone Given': phone },
        metric:{ data:{ type:'metric', attributes:{ name:'Wanted Sold Out Item' } } },
        profile:{ data:{ type:'profile', attributes: idAttrs } } } } };
      fetch('https://a.klaviyo.com/client/events/?company_id=UgshUa',
        { method:'POST', headers:H, body: JSON.stringify(ev) }).catch(function(){});
      try{ if(window.klaviyo) klaviyo.identify(idAttrs.email ? {'$email':idAttrs.email} : {'$phone_number':phone}); }catch(_){}
      try{ localStorage.setItem('glv_popup_v1', JSON.stringify({subscribed:true})); }catch(_){}
      document.getElementById('nForm').classList.add('hiddenv');
      document.getElementById('nDone').classList.remove('hiddenv');
    }
    var emailMode = emailWrap && !emailWrap.classList.contains('hiddenv');
    if (emailMode){
      /* phone was rejected earlier — capture them by email instead, phone kept as a property */
      var em = (emailEl.value||'').trim();
      if(!em || !/.+@.+\..+/.test(em)){
        msgEl.textContent='Enter a valid email.'; msgEl.className='msg err';
        btn.disabled=false; btn.textContent='Text Me The Code'; return;
      }
      var fb = { data:{ type:'subscription', attributes:{ profile:{ data:{ type:'profile', attributes:{
        email: em,
        properties: { 'Last Wanted Item': current.title, 'Unverified Phone': phone },
        subscriptions:{ email:{ marketing:{ consent:'SUBSCRIBED' } } } } } } },
        relationships:{ list:{ data:{ type:'list', id:'WVxK3Z' } } } } };
      if (NOTIFY_IP) fb.data.attributes.profile.data.attributes.location = { ip: NOTIFY_IP };
      fetch(KURL, { method:'POST', headers:H, body: JSON.stringify(fb) })
      .then(function(res){
        if(!(res.ok || res.status === 202)) throw new Error('bad');
        var sub2=document.getElementById('nDoneSub');
        if(sub2) sub2.textContent='Your code arrives by email 1 hour before the next drop opens.';
        finish(NOTIFY_IP ? { email: em, location:{ ip:NOTIFY_IP } } : { email: em });
      })
      .catch(function(){
        msgEl.textContent='Something went wrong. Please try again.'; msgEl.className='msg err';
        btn.disabled=false; btn.textContent='Text Me The Code';
      });
      return;
    }
    fetch(KURL, { method:'POST', headers:H, body: JSON.stringify(sub) })
    .then(function(res){
      if(res.ok || res.status === 202){
        finish(NOTIFY_IP ? { phone_number: phone, location:{ ip:NOTIFY_IP } } : { phone_number: phone });
        return;
      }
      return res.text().then(function(t){
        throw new Error(/phone_number|phone number/i.test(t) ? 'phone' : 'bad');
      });
    })
    .catch(function(err){
      if (err && err.message === 'phone' && emailWrap){
        emailWrap.classList.remove('hiddenv');
        msgEl.textContent='That number can\u2019t receive texts. Double-check it \u2014 or drop your email instead.';
      } else {
        msgEl.textContent='Something went wrong. Please try again.';
      }
      msgEl.className='msg err';
      btn.disabled=false; btn.textContent='Text Me The Code';
    });
  });
})();

/* ================= slide-out cart drawer ================= */
window.GLVCart = (function(){
  var scrim = document.getElementById('cartDrawer');
  if (!scrim) return {};
  var panel   = scrim.querySelector('.cd-panel');
  var itemsEl = document.getElementById('cdItems');
  var emptyEl = document.getElementById('cdEmpty');
  var totalEl = document.getElementById('cdTotal');
  var savedEl = document.getElementById('cdSaved');
  var payBtn  = document.getElementById('cdCheckout');
  var shipEl  = document.getElementById('cdShip');
  var shipMsg = document.getElementById('cdShipMsg');
  var shipFill= document.getElementById('cdShipFill');
  var busy = false;

  function money(cents){
    var n = (cents||0)/100;
    var s = n % 1 === 0 ? n.toFixed(0) : n.toFixed(2);
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(t){ return String(t==null?'':t).replace(/[&<>"]/g, function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  function open(){
    scrim.classList.add('open');
    scrim.setAttribute('aria-hidden','false');
    document.body.classList.add('cd-locked');
  }
  function close(){
    scrim.classList.remove('open');
    scrim.setAttribute('aria-hidden','true');
    document.body.classList.remove('cd-locked');
  }

  function render(cart){
    var n = cart.items ? cart.items.length : 0;
    emptyEl.style.display = n ? 'none' : '';
    payBtn.disabled = !n;

    var html = '', saved = 0;
    (cart.items||[]).forEach(function(it){
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      var wasEach = it.original_price > it.final_price ? it.original_price : 0;
      if (wasEach) saved += (wasEach - it.final_price) * it.quantity;
      html += '<div class="cd-item" data-key="'+esc(it.key)+'">'
        +   '<img src="'+(it.image ? esc(it.image) : '')+'" alt=""/>'
        +   '<div>'
        +     '<div class="cd-item-name">'+esc(it.product_title)+'</div>'
        +     (variant ? '<div class="cd-item-var">'+esc(variant)+'</div>' : '')
        +     '<div>'
        +       '<span class="cd-qty">'
        +         '<button type="button" data-act="dec" aria-label="Decrease">&minus;</button>'
        +         '<span>'+it.quantity+'</span>'
        +         '<button type="button" data-act="inc" aria-label="Increase">+</button>'
        +       '</span>'
        +       '<button class="cd-rm" type="button" data-act="rm">Remove</button>'
        +     '</div>'
        +   '</div>'
        +   '<div class="cd-item-price">'+money(it.final_line_price)
        +     (wasEach ? '<span class="cd-item-was">'+money(wasEach*it.quantity)+'</span>' : '')
        +   '</div>'
        + '</div>';
    });
    itemsEl.innerHTML = html;

    totalEl.textContent = money(cart.total_price);
    if (saved > 0){ savedEl.textContent = 'You saved ' + money(saved); savedEl.classList.remove('hiddenv'); }
    else savedEl.classList.add('hiddenv');

    if (typeof renderSwap === 'function') renderSwap(cart);
    if (typeof recommend === 'function') recommend(cart);

    if (shipEl){
      var need = parseInt(shipEl.dataset.threshold, 10) || 0;
      var have = cart.total_price || 0;
      if (need > 0){
        var pct = Math.max(0, Math.min(100, have / need * 100));
        shipFill.style.width = pct + '%';
        var unlocked = have >= need;
        shipEl.classList.toggle('done', unlocked);
        shipMsg.innerHTML = unlocked
          ? 'You&rsquo;ve unlocked free shipping'
          : 'Spend <b>' + money(need - have) + '</b> more for free shipping';
      }
    }
  }

  function refresh(){
    return fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){ render(c); return c; })
      .catch(function(){});
  }

  function add(id, qty){
    if (busy) return Promise.resolve();
    busy = true;
    return fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id:id, quantity:qty||1}]})
    }).then(function(r){ return r.json(); })
      .then(function(){ return refresh(); })
      .then(function(){ busy = false; open(); })
      .catch(function(){ busy = false; });
  }

  function change(key, qty){
    if (busy) return;
    busy = true;
    fetch('/cart/change.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({id:key, quantity:qty})
    }).then(function(r){ return r.json(); })
      .then(function(c){ render(c); busy = false; })
      .catch(function(){ busy = false; });
  }

  /* --- wiring --- */
  scrim.addEventListener('click', function(e){
    if (e.target === scrim || (e.target.classList && e.target.classList.contains('cd-x'))) close();
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && scrim.classList.contains('open')) close();
  });

  itemsEl.addEventListener('click', function(e){
    var b = e.target.closest('[data-act]'); if (!b) return;
    var row = e.target.closest('.cd-item'); if (!row) return;
    var key = row.dataset.key;
    var cur = parseInt(row.querySelector('.cd-qty span').textContent, 10) || 1;
    var act = b.dataset.act;
    if (act === 'inc') change(key, cur + 1);
    else if (act === 'dec') change(key, Math.max(0, cur - 1));
    else if (act === 'rm') change(key, 0);
  });

  var swapEl = document.getElementById('cdSwap');
  var upsell = document.getElementById('cdUpsell');
  var upsellRow = document.getElementById('cdUpsellRow');
  var curated = upsellRow && upsellRow.children.length > 0;   /* collection was set in settings */
  if (curated) upsell.classList.remove('hiddenv');

  if (upsell) upsell.addEventListener('click', function(e){
    var b = e.target.closest('.cd-up-add'); if (!b) return;
    add(b.dataset.vid, 1);
  });

  /* bundle swap: holding the individual pieces? offer the bundle as a one-tap Replace */
  function renderSwap(cart){
    if (!swapEl) return;
    var B = window.GLV_BUNDLE;
    if (!B || !cart.items || !cart.items.length){ swapEl.classList.add('hiddenv'); return; }
    var hasBundle = cart.items.some(function(i){ return i.product_id === B.pid; });
    var parts = cart.items.filter(function(i){ return B.parts.indexOf(i.product_id) !== -1; });
    if (hasBundle || !parts.length){ swapEl.classList.add('hiddenv'); return; }

    /* the bundle consumes ONE of each piece — value it that way, not the whole line */
    var oneEach = parts.reduce(function(t,i){ return t + i.final_price; }, 0);
    var save = oneEach - B.price;
    /* NOTE: Shopify line keys contain ':' — never delimiter-encode them */
    var spec = parts.map(function(i){ return {k:i.key, q:i.quantity}; });
    swapEl.innerHTML =
        '<div class="cd-swap-card" data-parts="'+esc(JSON.stringify(spec))+'">'
      +   '<img src="'+esc(B.img)+'" alt=""/>'
      +   '<div class="cd-swap-info">'
      +     '<div class="cd-swap-name">'+esc(B.title)+'</div>'
      +     '<div class="cd-swap-price">'+money(B.price)
      +       (save > 0 ? '<span class="cd-swap-save">Save '+money(save)+'</span>' : '')
      +     '</div>'
      +   '</div>'
      +   '<button class="cd-swap-btn" type="button">Replace</button>'
      + '</div>';
    swapEl.classList.remove('hiddenv');
  }

  if (swapEl) swapEl.addEventListener('click', function(e){
    var b = e.target.closest('.cd-swap-btn'); if (!b || busy) return;
    var card = e.target.closest('.cd-swap-card');
    var spec;
    try { spec = JSON.parse(card.dataset.parts || '[]'); } catch(_){ spec = []; }
    var B = window.GLV_BUNDLE; if (!B || !spec.length) return;
    busy = true; b.disabled = true; b.textContent = 'Swapping...';
    /* one bundle consumes one of each piece — decrement, never wipe the line */
    spec.reduce(function(chain, part){
      var key  = part.k;
      var left = Math.max(0, (parseInt(part.q, 10) || 1) - 1);
      return chain.then(function(){
        return fetch('/cart/change.js', {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({id:key, quantity:left})
        });
      });
    }, Promise.resolve())
    .then(function(){
      return fetch('/cart/add.js', {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({items:[{id:B.vid, quantity:1}]})
      });
    })
    .then(function(){ busy = false; return refresh(); })
    .catch(function(){ busy = false; b.disabled = false; b.textContent = 'Replace'; });
  });

  /* no curated collection -> use Shopify's own recommendations for what's in the cart */
  var recDone = null;
  function recommend(cart){
    if (curated || !upsell || !upsellRow) return;
    if (!cart.items || !cart.items.length){ upsell.classList.add('hiddenv'); return; }
    var seed = cart.items[0].product_id;
    if (recDone === seed) return;                 /* already fetched for this seed */
    recDone = seed;
    fetch('/recommendations/products.json?product_id='+seed+'&limit=8&intent=related',
          {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(d){
        var html = '', n = 0, used = {};
        function tile(title, img, cents, vid){
          return '<div class="cd-up">'
               +   '<img src="'+esc(img)+'" alt="" loading="lazy"/>'
               +   '<div class="cd-up-name">'+esc(title)+'</div>'
               +   '<div class="cd-up-price">'+money(cents)+'</div>'
               +   '<button class="cd-up-add" type="button" data-vid="'+vid+'">+</button>'
               + '</div>';
        }
        function apply(){
          upsellRow.innerHTML = html;
          upsell.classList.toggle('hiddenv', n === 0);
        }
        (d.products||[]).forEach(function(p){
          if (n >= 6 || !p.available) return;   /* in-cart items stay visible — + adds another */
          if (/route|shipping protection/i.test(p.title)) return;   /* never upsell the insurance app */
          var v = (p.variants||[]).filter(function(x){ return x.available; })[0];
          if (!v) return;
          used[p.id] = 1; n++;
          html += tile(p.title, p.featured_image || (p.images && p.images[0]) || '', v.price, v.id);
        });
        if (n >= 3){ apply(); return; }
        /* small catalogue: related-products runs thin, so top up from the full list.
           NOTE: /products.json prices are DOLLAR STRINGS, recommendations are cents. */
        return fetch('/products.json?limit=50', {headers:{'Accept':'application/json'}})
          .then(function(r){ return r.json(); })
          .then(function(all){
            (all.products||[]).forEach(function(p){
              if (n >= 6 || used[p.id]) return;
              if (/route|shipping protection/i.test(p.title)) return;
              var v = (p.variants||[]).filter(function(x){ return x.available; })[0];
              if (!v) return;
              var img = (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
              used[p.id] = 1; n++;
              html += tile(p.title, img, Math.round(parseFloat(v.price) * 100), v.id);
            });
          })
          .catch(function(){})
          .then(apply);
      })
      .catch(function(){ upsell.classList.add('hiddenv'); });
  }

  payBtn.addEventListener('click', function(){ window.location.href = '/checkout'; });

  /* header cart icon opens the drawer instead of navigating */
  document.querySelectorAll('a.cartlink').forEach(function(a){
    a.addEventListener('click', function(e){ e.preventDefault(); refresh().then(open); });
  });

  /* product form -> ajax add */
  document.querySelectorAll('form[action^="/cart/add"]').forEach(function(f){
    f.addEventListener('submit', function(e){
      var idField = f.querySelector('[name="id"]');
      if (!idField) return;                    /* let it post normally */
      e.preventDefault();
      var btn = f.querySelector('button[type="submit"]');
      var label = btn ? btn.textContent : '';
      if (btn){ btn.disabled = true; btn.textContent = 'Adding...'; }
      add(idField.value, 1).then(function(){
        if (btn){ btn.disabled = false; btn.textContent = label; }
      });
    });
  });

  refresh();
  return {open:open, close:close, add:add, refresh:refresh};
})();


/* ---------- GLVSSIC sales pop: recent real purchases (fed by order webhook) ---------- */
(function(){
  var FEED = 'https://script.google.com/macros/s/AKfycbwllQmu6UqnwMUwX86X5X5rCvOEn-Glb--pDMMuqKcspLwid9h2hTPmEGWZ-ZSuiCcF/exec?feed=orders';
  var MAX_AGE_H = 72, SHOW_MS = 6500, MIN_GAP = 12000, MAX_GAP = 26000, MAX_SHOWS = 12;
  try { if (sessionStorage.getItem('glv_pop_off') === '1') return; } catch(e){}

  var stop = false, shows = 0, imgMap = {};
  var card = document.createElement('div');
  card.id = 'glvPop';
  card.innerHTML = '<button class="gp-x" aria-label="Dismiss">&#10005;</button>' +
    '<img class="gp-img" alt=""/>' +
    '<div class="gp-body"><div class="gp-t"></div><div class="gp-p"></div><div class="gp-s"></div></div>';
  document.body.appendChild(card);
  var imgEl = card.querySelector('.gp-img'),
      tEl = card.querySelector('.gp-t'),
      pEl = card.querySelector('.gp-p'),
      sEl = card.querySelector('.gp-s');
  card.querySelector('.gp-x').addEventListener('click', function(e){
    e.stopPropagation();
    card.classList.remove('on');
    stop = true;
    try { sessionStorage.setItem('glv_pop_off', '1'); } catch(err){}
  });

  function ago(t){
    var m = Math.max(1, Math.round((Date.now() - t) / 60000));
    if (m < 60) return 'Purchased ' + m + (m === 1 ? ' minute ago' : ' minutes ago');
    var h = Math.round(m / 60);
    if (h < 24) return 'Purchased ' + h + (h === 1 ? ' hour ago' : ' hours ago');
    var d = Math.round(h / 24);
    return 'Purchased ' + d + (d === 1 ? ' day ago' : ' days ago');
  }
  function imgFor(title){
    var k = (title || '').toLowerCase();
    if (imgMap[k]) return imgMap[k];
    for (var key in imgMap){ if (k.indexOf(key) > -1 || key.indexOf(k) > -1) return imgMap[key]; }
    return '';
  }
  function show(o){
    var src = imgFor(o.p);
    if (src){ imgEl.src = src; imgEl.style.display = ''; } else { imgEl.style.display = 'none'; }
    tEl.textContent = (o.n || 'Someone') + (o.c ? ' in ' + o.c : '') + ' purchased';
    pEl.textContent = o.p;
    if (sEl) sEl.textContent = o.t ? ago(o.t) : '';
    card.classList.add('on');
    setTimeout(function(){ card.classList.remove('on'); }, SHOW_MS);
  }

  Promise.all([
    fetch(FEED).then(function(r){ return r.json(); }).catch(function(){ return []; }),
    fetch('/products.json?limit=250').then(function(r){ return r.json(); }).then(function(j){ return j.products || []; }).catch(function(){ return []; })
  ]).then(function(res){
    var list = res[0] || [], prods = res[1] || [];
    prods.forEach(function(p){
      var im = (p.images && p.images[0] && p.images[0].src) || '';
      if (im) imgMap[(p.title || '').toLowerCase()] = im;
    });
    var fresh = list.filter(function(o){ return o && o.p; });
    if (!fresh.length) return;
    var i = 0;
    function loop(){
      if (stop || shows >= MAX_SHOWS) return;
      if (!document.hidden){ show(fresh[i % fresh.length]); i++; shows++; }
      setTimeout(loop, SHOW_MS + MIN_GAP + Math.random() * (MAX_GAP - MIN_GAP));
    }
    setTimeout(loop, 3500);
  });
})();
